
export class EmploymentTypeRequestModel {
  employmentType : string;
  updatedUser ?: string;
  versionFlag: number;
}

export const EmploymentTypeRequestDefault: EmploymentTypeRequestModel = {
  employmentType: '',
  versionFlag: 0,
  updatedUser: '',
}

